import { ROUTE_SEGMENTS } from './rewrite'

type RouteParams = Record<string, string | string[] | undefined>

const UUID_SEGMENT =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

function decodeSafely(segment: string): string {
  try {
    return decodeURIComponent(segment)
  } catch {
    return segment
  }
}

function placeholdersByValue(params: RouteParams): Map<string, string> {
  const placeholders = new Map<string, string>()
  for (const [name, value] of Object.entries(params)) {
    if (value === undefined) continue
    const values = Array.isArray(value) ? value : [value]
    for (const entry of values) placeholders.set(entry, `[${name}]`)
  }
  return placeholders
}

function templateSegment(
  segment: string,
  placeholders: Map<string, string>,
): string {
  const decoded = decodeSafely(segment)
  const placeholder = placeholders.get(segment) ?? placeholders.get(decoded)
  if (placeholder) return placeholder
  if (UUID_SEGMENT.test(decoded)) return '[id]'
  // Fail closed: only known route segments survive, so an id Next did not
  // expose as a param must not leak.
  return segment === '' || ROUTE_SEGMENTS.has(segment) ? segment : '[id]'
}

export function templatePath(pathname: string, params: RouteParams): string {
  const placeholders = placeholdersByValue(params)
  const [pathOnly] = pathname.split(/[?#]/, 1)
  return pathOnly
    .split('/')
    .map(segment => templateSegment(segment, placeholders))
    .join('/')
}
